import { render, staticRenderFns } from "./LineChart.vue?vue&type=template&id=510bc797&scoped=true&"
import script from "./LineChart.vue?vue&type=script&lang=js&"
export * from "./LineChart.vue?vue&type=script&lang=js&"
import style0 from "./LineChart.vue?vue&type=style&index=0&id=510bc797&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510bc797",
  null
  
)

export default component.exports